module.exports = __webpack_public_path__ + "static/media/Car-example.4874774d.jpg";